import { render } from "./AddStatus.vue?vue&type=template&id=281016c9&ts=true"
import script from "./AddStatus.vue?vue&type=script&lang=ts"
export * from "./AddStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__